import React from "react";

import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "./ui/card";
import { StarRating } from "./ui/star-rating";
import { Link } from "react-router";
import { findSuitablePhoto } from "../helpers/photoHelpers";
import { glassImage } from "../helpers/logoHelpers";
import { convertLengthUnit } from "../helpers/unitHelpers";
import useFirebasePreferences from "../hooks/useFirebasePreferences";

const formatDimensions = (w: number, d: number, t: number, unit: string) =>
  `${w} \u00d7 ${d} \u00d7 ${t} ${unit}`;

const ProjectCard = (props: any) => {
  const preferences = useFirebasePreferences();
  const length_unit = props.length_unit || "mm";
  const desired_unit = (preferences && preferences.length_unit) || "mm";
  const width = convertLengthUnit(length_unit, desired_unit, props.width);
  const depth = convertLengthUnit(length_unit, desired_unit, props.depth);
  const thickness = convertLengthUnit(length_unit, desired_unit, props.thickness);
  const photoUrl = findSuitablePhoto(props, "small")?.uri;
  const hasDimensions = props.width || props.depth || props.thickness;

  return (
    <Link to={`/projects/${props.id}`}>
      <Card className="overflow-hidden cursor-pointer hover:shadow-md transition-shadow h-full flex flex-col py-0 gap-0">
        <div
          className="aspect-[4/3] overflow-hidden"
          style={
            photoUrl
              ? undefined
              : { backgroundImage: "linear-gradient(135deg, #2b3b4f, #5b7f9f)" }
          }
        >
          {photoUrl && (
            <img src={photoUrl} alt={props.name || ""} className="w-full h-full object-cover" />
          )}
        </div>

        <CardHeader className="pt-[14px] pb-0">
          <CardTitle className="text-sm leading-tight line-clamp-1">{props.name}</CardTitle>
          {props.kilnName && (
            <CardDescription className="text-xs mt-0.5">{props.kilnName}</CardDescription>
          )}
        </CardHeader>

        <CardContent className="flex-1 py-2">
          <div className="flex items-center gap-2">
            <img
              className="h-[22px] w-[22px] rounded-full object-cover bg-white border border-border"
              src={glassImage(props.glass)}
              alt=""
            />
            <StarRating maxRating={5} rating={props.stars} />
          </div>
        </CardContent>

        {hasDimensions && (
          <CardFooter className="text-xs text-muted-foreground pt-0 pb-4">
            {formatDimensions(width, depth, thickness, desired_unit)}
          </CardFooter>
        )}
      </Card>
    </Link>
  );
};

export default ProjectCard;
